const Skeleton = () => {
	return (
		<div className="detailedSkeleton">
			<div className="detailedInnerSkeleton">
				<div className="detailedTitleSkeleton skeleton"></div>
				<div className="detailedInfoSkeleton skeleton"></div>
				<div className="detailedOtherOptionsSkeleton skeleton"></div>
				<div className="detailedImageSkeleton skeleton"></div>
			</div>
		</div>
	)
}

export default Skeleton
